// Puerto verbatim de packages/hce/src/hce/paciente/TrendSvgChart.tsx — SVG
// puro, sin librería, sin dependencia de Mantine (solo el color default
// cambia de variable CSS de Mantine a la nuestra).
import type { JSX } from 'react';

export interface TrendSvgChartProps {
  readonly values: number[];
  readonly color?: string;
  readonly width?: number;
  readonly height?: number;
}

export function TrendSvgChart({ values, color = 'var(--color-hce-clay)', width = 100, height = 44 }: TrendSvgChartProps): JSX.Element | null {
  if (values.length < 2) return null;

  const min = Math.min(...values);
  const max = Math.max(...values);
  const rango = max - min || 1;
  const minConMargen = min - rango * 0.1;
  const rangoConMargen = rango * 1.2 || 1;

  const puntos = values.map((v, i) => {
    const x = (i / (values.length - 1)) * width;
    const y = height - ((v - minConMargen) / rangoConMargen) * height;
    return [x, y] as const;
  });

  const linea = puntos.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const area = `M0,${height} L${puntos.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' L')} L${width},${height} Z`;
  const ultimo = puntos[puntos.length - 1];

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" style={{ display: 'block' }}>
      <path d={area} fill={color} fillOpacity={0.09} />
      <polyline points={linea} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" />
      <circle cx={ultimo[0]} cy={ultimo[1]} r={2.4} fill={color} />
    </svg>
  );
}
